<template>
  <div>
    <a-card size="small" :bordered="false">
      <span style="margin-right: 8px">时间:</span>
      <a-range-picker v-model="checkedDate" :allow-clear="false" />
    </a-card>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  name: 'TimeFilter',
  data() {
    return {
      checkedDate: [moment().subtract(1, 'month').add(1, 'day'), moment()]
    };
  },
  watch: {
    checkedDate() {
      this.$emit('change', this.checkedDate);
    }
  },
  created() {
    this.$emit('change', this.checkedDate);
  }
};
</script>

<style lang="less" scoped>
.ant-form-item {
  margin-bottom: 0px;
  border-bottom: silver 1px dashed;
}
</style>
